import researchCards from "./researchCardsData.json";

export const MAX_RESEARCH_MODELS = 5;

export const RESEARCH_MODELS = [
  {
    key: "chatgpt",
    name: "ChatGPT",
    accent: "#10a37f",
    logo: "/openai-icon.svg",
  },
  {
    key: "claude",
    name: "Claude",
    accent: "#d97757",
    logoCdn: "claude",
  },
  {
    key: "gemini",
    name: "Gemini",
    accent: "#4285f4",
    logoCdn: "googlegemini",
  },
  {
    key: "perplexity",
    name: "Perplexity",
    accent: "#20808d",
    logoCdn: "perplexity",
  },
  {
    key: "grok",
    name: "Grok",
    accent: "#111827",
    logo: "/grok-icon.jpeg",
  },
];

const cardByKey = Object.fromEntries(researchCards.map((c) => [c.key, c]));

/** @param {string} key */
export function getResearchCard(key) {
  return cardByKey[key];
}

export function modelLogoSrc(model) {
  if (model.logo) return model.logo;
  return `https://cdn.simpleicons.org/${model.logoCdn}/${model.accent.replace("#", "")}`;
}
